import React, { useState, useEffect, ReactElement } from 'react';
import { isDarkMode } from '../../utils/helpers';
import './toggle-button.css';

const ToggleButton = (props: any): ReactElement => {
  const {
    isChecked,
    title,
    id,
    onChangeHandler,
    customStyle,
    radioBehaviour = false,
    hideIcons = false,
    labelStyle = {},
    dataTestId = '',
    isDisabled = false,
    elementRef,
  } = props;
  const [checked, setChecked] = useState(false);
  const [isAnimating, toggleAnimating] = useState(false);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const darkModeToggle = {
    border: `solid 1px ${isDarkMode() && !isChecked ? '#71B5E4' : isDarkMode() ? '#2B8FD7' : '#2B8FD7'}`,
  };

  const customLabelStyle = {
    color: isDisabled
      ? '#2B8FD7'
      : isDarkMode() && !isChecked
        ? '#71B5E4'
        : isDarkMode()
          ? '#FFFFFF'
          : !isChecked
            ? '#2B8FD7'
            : '#FFFFFF',
  };

  const ping = () => {
    toggleAnimating(false);
  };

  const toggleChecked = e => {
    if (isAnimating || isDisabled) {
      return false;
    } else {
      !radioBehaviour && setChecked(!checked);
      toggleAnimating(true);
      onChangeHandler(e, !checked);
    }
  };

  const composeStateClasses = core => {
    let result = core;

    if (checked) {
      result += ' is-checked';
    } else {
      result += ' is-unchecked';
    }

    if (isAnimating) {
      result += ' do-ping';
    }
    return result;
  };

  const cl = composeStateClasses('ui-checkbox-btn');

  const showIcons = () => {
    if (!hideIcons) {
      return !checked ? (
        <i className="icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.00002 11.6364C8.20608 11.6364 8.37893 11.5666 8.51857 11.4269C8.65772 11.2878 8.72729 11.1152 8.72729 10.9091V8.72729H10.9273C11.1334 8.72729 11.3031 8.65748 11.4364 8.51784C11.5697 8.37869 11.6364 8.20608 11.6364 8.00002C11.6364 7.79396 11.5666 7.62111 11.4269 7.48148C11.2878 7.34232 11.1152 7.27275 10.9091 7.27275H8.72729V5.07275C8.72729 4.86669 8.65772 4.69699 8.51857 4.56366C8.37893 4.43033 8.20608 4.36366 8.00002 4.36366C7.79396 4.36366 7.62136 4.43323 7.4822 4.57239C7.34257 4.71202 7.27275 4.88487 7.27275 5.09093V7.27275H5.07275C4.86669 7.27275 4.69699 7.34232 4.56366 7.48148C4.43033 7.62111 4.36366 7.79396 4.36366 8.00002C4.36366 8.20608 4.43323 8.37869 4.57239 8.51784C4.71202 8.65748 4.88487 8.72729 5.09093 8.72729H7.27275V10.9273C7.27275 11.1334 7.34257 11.3031 7.4822 11.4364C7.62136 11.5697 7.79396 11.6364 8.00002 11.6364ZM8.00002 15.2727C6.99396 15.2727 6.04851 15.0817 5.16366 14.6997C4.27881 14.3181 3.50911 13.8 2.85457 13.1455C2.20002 12.4909 1.68196 11.7212 1.30039 10.8364C0.918325 9.95154 0.727295 9.00608 0.727295 8.00002C0.727295 6.99396 0.918325 6.04851 1.30039 5.16366C1.68196 4.27881 2.20002 3.50911 2.85457 2.85457C3.50911 2.20002 4.27881 1.68172 5.16366 1.29966C6.04851 0.918083 6.99396 0.727295 8.00002 0.727295C9.00608 0.727295 9.95154 0.918083 10.8364 1.29966C11.7212 1.68172 12.4909 2.20002 13.1455 2.85457C13.8 3.50911 14.3181 4.27881 14.6997 5.16366C15.0817 6.04851 15.2727 6.99396 15.2727 8.00002C15.2727 9.00608 15.0817 9.95154 14.6997 10.8364C14.3181 11.7212 13.8 12.4909 13.1455 13.1455C12.4909 13.8 11.7212 14.3181 10.8364 14.6997C9.95154 15.0817 9.00608 15.2727 8.00002 15.2727ZM8.00002 13.8182C9.61214 13.8182 10.985 13.2517 12.1186 12.1186C13.2517 10.985 13.8182 9.61214 13.8182 8.00002C13.8182 6.3879 13.2517 5.01505 12.1186 3.88148C10.985 2.74839 9.61214 2.18184 8.00002 2.18184C6.3879 2.18184 5.01529 2.74839 3.8822 3.88148C2.74863 5.01505 2.18184 6.3879 2.18184 8.00002C2.18184 9.61214 2.74863 10.985 3.8822 12.1186C5.01529 13.2517 6.3879 13.8182 8.00002 13.8182Z"
              fill={isDisabled ? '#2B8FD7' : 'rgb(36, 145, 222)'}
            />
          </svg>
        </i>
      ) : (
        <i className="icon">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="rounded/DismissCancel">
              <path
                id="icon_art"
                d="M6.5 7.88403L1.65589 12.7281C1.47465 12.9094 1.24398 13 0.963878 13C0.683777 13 0.453105 12.9094 0.271863 12.7281C0.090621 12.5469 0 12.3162 0 12.0361C0 11.756 0.090621 11.5253 0.271863 11.3441L5.11597 6.5L0.271863 1.65589C0.090621 1.47465 0 1.24398 0 0.963878C0 0.683777 0.090621 0.453105 0.271863 0.271863C0.453105 0.090621 0.683777 0 0.963878 0C1.24398 0 1.47465 0.090621 1.65589 0.271863L6.5 5.11597L11.3441 0.271863C11.5253 0.090621 11.756 0 12.0361 0C12.3162 0 12.5469 0.090621 12.7281 0.271863C12.9094 0.453105 13 0.683777 13 0.963878C13 1.24398 12.9094 1.47465 12.7281 1.65589L7.88403 6.5L12.7281 11.3441C12.9094 11.5253 13 11.756 13 12.0361C13 12.3162 12.9094 12.5469 12.7281 12.7281C12.5469 12.9094 12.3162 13 12.0361 13C11.756 13 11.5253 12.9094 11.3441 12.7281L6.5 7.88403Z"
                fill="#CAE3F5"
              />
            </g>
          </svg>
        </i>
      );
    }
  };

  return (
    <div
      id={id}
      ref={elementRef}
      data-test-id={dataTestId ? `cy-${dataTestId}` : `cy-toggle-${id}`}
      className={cl}
      onClick={toggleChecked}
      style={isDarkMode() ? { ...darkModeToggle, ...customStyle } : customStyle}
    >
      <input className="ui ui-checkbox" type="checkbox" checked={isChecked} readOnly />
      {showIcons()}
      <label className="text" style={{ ...customLabelStyle, ...labelStyle }}>
        {title}
      </label>
      <div className="ui-btn-ping" onTransitionEnd={ping}></div>
    </div>
  );
};

export default ToggleButton;
